export default {
  data () {
    return {
      zoomCount: 0,
      zoomLimit: 5,
      processingZoom: false
    }
  },
  computed: {
    enableZoomIn: function () {
      return (this.zoomCount < this.zoomLimit && !this.processingZoom)
    },
    enableZoomOut: function () {
      return (this.zoomCount > 0 && !this.processingZoom)
    }
  },
  methods: {
    zoomIn () {
      if (this.processingZoom) { return }
      this.processingZoom = true
      this.scaleScore = this.scaleScore + 0.1
      this.stage.width(this.imageObj.width * this.scaleScore)
      this.stage.height(this.imageObj.height * this.scaleScore)
      this.stage.scale({ x: this.scaleScore, y: this.scaleScore })
      this.stage.batchDraw()
      this.zoomCount++
      this.updateZoomFinish()
    },
    zoomOut () {
      if (this.processingZoom) { return }
      this.processingZoom = true
      this.scaleScore = this.scaleScore - 0.1
      this.stage.width(this.imageObj.width * this.scaleScore)
      this.stage.height(this.imageObj.height * this.scaleScore)
      this.stage.scale({ x: this.scaleScore, y: this.scaleScore })
      this.zoomCount--
      this.stage.batchDraw()
      this.updateZoomFinish()
    },
    updateZoomFinish () {
      this.$nextTick(() => {
        this.processingZoom = false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/zoom.js